import { apiRequest } from "../index";

export const getWalletTransactions = async () => {
  return apiRequest(`/api/common/wallet`, "GET");
};

